var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03418 13.0355C6.03418 12.6282 6.20835 12.2981 6.4232 12.2981H13.4256C13.6405 12.2981 13.8146 12.6282 13.8146 13.0355C13.8146 13.4427 13.6405 13.7729 13.4256 13.7729H6.4232C6.20835 13.7729 6.03418 13.4427 6.03418 13.0355Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80461 4.0376C4.96259 4.0376 1.03735 7.96402 1.03735 12.8075C1.03735 17.651 4.96259 21.5774 9.80461 21.5774C11.9386 21.5774 13.8946 20.8147 15.4149 19.547L21.4621 25.596C21.7733 25.9073 22.278 25.9073 22.5892 25.596C22.9005 25.2846 22.9005 24.7798 22.5892 24.4685L16.5421 18.4195C17.8094 16.8987 18.5719 14.9422 18.5719 12.8075C18.5719 7.96402 14.6466 4.0376 9.80461 4.0376ZM2.6314 12.8075C2.6314 8.84466 5.84296 5.63213 9.80461 5.63213C13.7663 5.63213 16.9778 8.84466 16.9778 12.8075C16.9778 16.7704 13.7663 19.9829 9.80461 19.9829C5.84296 19.9829 2.6314 16.7704 2.6314 12.8075Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.a7e2f79e.svg";
export { ForwardRef as ReactComponent };